module.exports = __webpack_public_path__ + "baaa472dff90ae7ecb06e0704fff2da1.png";